import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input, InputGroup, InputGroupAddon, InputGroupText, FormFeedback } from 'reactstrap';

class File extends Component {

	constructor(props) {
		super(props);
		this.state = {
			files: null,
			value: '',
		};

		this.fileInputRef = React.createRef();

		this.onChange = this.onChange.bind(this);
		this.handleBrowserClick = this.handleBrowserClick.bind(this);
	}

	onChange(event) {
		let input = event.target;
		let { onChange } = this.props;
		let files = this.getSelectedFiles(input);

		if (typeof onChange === 'function')
			onChange(event);

		this.setState({files});
	}

	getSelectedFiles(input) {
		let files = Object.values(input.files).map(file => file.name);
		return files.join(', ');
	}

	handleBrowserClick(event) {
		if (this.props.readOnly)
			return;
		this.fileInputRef.current.click();
	}

	render() {
		const { className, label, onChange, children, innerRef, accept, buttonText, placeholder, value, valid, feedback, required, readOnly, ...attributes } = this.props;
		const { files } = this.state;

		return (
			<div>
				<input className="d-none" type="file" accept={accept} {...attributes} ref={this.fileInputRef} onChange={this.onChange} />
				<InputGroup>
					<Input
						onChange={() => {}}
						value={files || ''}
						placeholder={label || placeholder || 'Choose file'}
						onClick={this.handleBrowserClick}
						valid={valid}
						invalid={valid===false ? true : undefined}
						required={required}
						disabled={readOnly}
					/>
					<InputGroupAddon addonType="append" onClick={this.handleBrowserClick}>
						<InputGroupText>{buttonText || 'Browse'}</InputGroupText>
					</InputGroupAddon>
					{ feedback &&
						<FormFeedback>{feedback}</FormFeedback>
					}
				</InputGroup>
			</div>
		);
	}
}

File.propTypes = {
	className: PropTypes.string,
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	label: PropTypes.node,
	onChange: PropTypes.func,
	children: PropTypes.oneOfType([PropTypes.node, PropTypes.array, PropTypes.func]),
	innerRef: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.string,
		PropTypes.func,
	]),
	buttonText: PropTypes.string,
	placeholder: PropTypes.string,
	valid: PropTypes.bool,
	feedback: PropTypes.string,
};

export default File;
